import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tierpaedagogik',
  templateUrl: './tierpaedagogik.component.html',
  styleUrls: ['./tierpaedagogik.component.scss']
})
export class TierpaedagogikComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
